import styled from "astroturf";

import { Section as SectionUI } from "../styles";

export const Section = styled(SectionUI)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1rem;
  height: 31rem;
`;
